module.exports = __webpack_public_path__ + "img/vessel_visitation_2_63021.a18afb02.jpg";